import _regenerator from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
/* eslint-disable no-multi-spaces */
/* eslint-disable keyword-spacing */
/* eslint-disable space-before-blocks */
/* eslint-disable eqeqeq */
/* eslint-disable space-infix-ops */
/* eslint-disable semi */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */
/* eslint-disable quotes */
/* eslint-disable indent */
/**
 * Implementation based on https://github.com/AzureAD/microsoft-authentication-library-for-js/tree/dev/lib/msal-browser
 */
/* 
* Using certificate credentials with MSAL Node: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-node/docs/certificate-credentials.md
*/

import * as Msal from '@azure/msal-browser';
var envConfig = {
  clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
  tenantId: process.env.VUE_APP_MSAL_TENANT_ID,
  redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI,
  logoutUri: process.env.VUE_APP_MSAL_LOGOUT_URI
};
console.log('process.env: ', process.env);
console.log('masl config: ', envConfig);
var msalConfig = {
  auth: {
    clientId: envConfig.clientId,
    authority: 'https://login.microsoftonline.com/' + envConfig.tenantId,
    redirectUri: envConfig.redirectUri,
    postLogoutRedirectUri: envConfig.logoutUri,
    navigateToLoginRequestUrl: false
  },
  system: {
    tokenRenewalOffsetSeconds: 300
  }
};
var loginRequestConfig = {
  scopes: ["openid", "profile", "email", msalConfig.auth.clientId + "/.default"],
  forceRefresh: true
};
function initMsalInstance() {
  return new Msal.PublicClientApplication(msalConfig);
}
function initLoginRequest() {
  return loginRequestConfig;
}
export function login() {
  var msalInstance = initMsalInstance();
  var loginRequest = initLoginRequest();
  msalInstance["browserStorage"].clear();

  // https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/errors.md#using-loginredirect-or-acquiretokenredirect
  msalInstance.handleRedirectPromise().then(function (res) {
    console.log('login.handleRedirectPromise res: ', res);
    var accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0 || !res) {
      // No user signed in
      msalInstance.loginRedirect(loginRequest);
    }
  }).catch(function (err) {
    console.log('login.handleRedirectPromise error: ', err);
  });
}
export function getAccessToken() {
  return _getAccessToken.apply(this, arguments);
}
function _getAccessToken() {
  _getAccessToken = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var msalInstance, loginRequest;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          msalInstance = initMsalInstance();
          loginRequest = initLoginRequest();
          return _context.a(2, msalInstance.handleRedirectPromise().then(function (res) {
            console.log('getAccessToken.handleRedirectPromise res: ', res);
            if (!res) {
              console.log('acquireTokenRedirect');
              return msalInstance.acquireTokenRedirect(loginRequest);
            } else {
              var account = msalInstance.getAllAccounts()[0];
              console.log('acquireTokenSilent for account: ', account);
              loginRequest.account = account;
              return msalInstance.acquireTokenSilent(loginRequest);
            }
          }).catch(function (err) {
            console.log('getAccessToken.handleRedirectPromise error: ', err);
          }));
      }
    }, _callee);
  }));
  return _getAccessToken.apply(this, arguments);
}
export function logout() {
  var msalInstance = initMsalInstance();
  msalInstance.handleRedirectPromise().then(function (res) {
    console.log('logout.handleRedirectPromise res: ', res);
    if (!res) {
      msalInstance.logoutRedirect();
    }
  }).catch(function (err) {
    console.log('logout.handleRedirectPromise error: ', err);
  });
}
export function acquireTokenSilent() {
  var msalInstance = initMsalInstance('ups');
  return msalInstance.acquireTokenSilent({
    scopes: ["openid", "profile", "email", msalConfig.auth.clientId + "/.default"],
    // forceRefresh: true
    account: msalInstance.getAllAccounts()[0]
  });
}